/**
 * Basic dropdown navigation menu to be used with default global TopNav
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// import actions
import * as studyActions from '../../../modules/study/studyActions';
import * as studyUserActions from '../../../modules/studyUser/studyUserActions';
import * as userActions from '../../../modules/user/userActions';
import * as userEventActions from '../../../modules/userEvent/userEventActions';

// import components
import Base from "../BaseComponent.js.jsx";
import UserProfilePic from '../../../modules/user/components/UserProfilePic.js.jsx';

class ProfileDropdownNav extends Base {
  constructor(props) {
    super(props);
    this._bind(
      '_logout'
    )
  }

  componentDidMount() {
    const { dispatch, loggedInUser } = this.props;
    // grab the logged in user's list of studies
    dispatch(studyActions.fetchListIfNeeded("admin-or-view-analytics", loggedInUser._id));
  }

  _logout(e) {
    const { dispatch, history, loggedInUser } = this.props;
    dispatch(userActions.sendLogout()).then((action) => {
      if(action.success) {
        this.props.dispatch(userEventActions.sendCreateUserEvent({
          eventType: "user"
          , eventAction: "logout"
          , _user: loggedInUser._id // req.user is no longer defined here
        }));
        // redirect to index
        history.push('/');
      } else {
        // the user is redirected on auto logout directly from api.js
        console.log("ERROR LOGGING OUT - " + action.message);
      }
    })
  }

  render() {
    const { close, loggedInUser, isOpen, studyStore, viewAs } = this.props;

    const studiesAdminOrViewAnalytics = studyStore.util.getList("admin-or-view-analytics", loggedInUser._id) || [];

    let pictureUrl = '';
    if(loggedInUser && loggedInUser.profilePicUrl) {
      pictureUrl = loggedInUser.profilePicUrl;
    }

    let profileImg = {backgroundImage: `url(${pictureUrl})`};

    const isAdmin = (
      loggedInUser
      && loggedInUser.admin
    )

    const canViewAnalytics = (
      studiesAdminOrViewAnalytics
      && studiesAdminOrViewAnalytics.length > 0
      || isAdmin
    )

    const agendaLink = `${window.agendaUrl}/agenda`
    const certsLink = `${window.agendaUrl}/certificates`
    const profileUrl = `${window.hubUrl}/user/profile`
    const dashboardLink = `${window.hubUrl}`

    return(
      <TransitionGroup >
        { isOpen ?
          <CSSTransition
            classNames="dropdown-anim"
            timeout={250}
          >
            <ul className="dropMenu">
              <div>
                <li className="-drop-header">
                  <UserProfilePic user={loggedInUser}/>
                  <div className="-profile-info">
                    {loggedInUser.firstName + " "} {loggedInUser.lastName}
                    <br/>
                    <small>{loggedInUser.username}</small>
                  </div>
                </li>
                <li><a href={agendaLink}>My Agenda</a></li>
                <li><a href={certsLink}>Certificates</a></li>
                {/* <li><Link to="/my-agenda/completed" onClick={() => close()}>Completed Training</Link></li> */}
                {/* <li><Link to="/my-agenda/expired" onClick={() => close()}>Expired Training</Link></li> */}
                <li role="separator" className="-divider"/>
                <li><a href={profileUrl}>My Profile </a></li>
                <li><a href={dashboardLink} target="_blank" onClick={() => close()}>Dashboard <i className="fa fa-external-link"/> </a></li>
                { isAdmin ?
                    <li><Link to="/admin/authoring" target="_blank" onClick={() => close()}>Go to Admin <i className="fa fa-external-link"/> </Link></li>
                  :
                    null
                }
                <li role="separator" className="-divider"/>
                <li><a onClick={this._logout}>Logout</a></li>
              </div>
            </ul>
            </CSSTransition>
          :
            null
        }
      </TransitionGroup>
    )
  }
}

ProfileDropdownNav.propTypes = {
  close: PropTypes.func.isRequired
  , dispatch: PropTypes.func.isRequired
  , isOpen: PropTypes.bool.isRequired
  , viewAs: PropTypes.oneOf(['user', 'admin', 'sponsor'])
}

ProfileDropdownNav.defaultProps = {
  viewAs: 'user'
}

const mapStoreToProps = (store) => {
  return {
    loggedInUser: store.user.loggedIn.user
    , studyStore: store.study
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ProfileDropdownNav)
);



// WEBPACK FOOTER //
// global/components/navigation/ProfileDropdownNav.js.jsx